import React, { useContext, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "../src/assets/css/style.css";
import "../src/assets/css/developer.css";
import "../src/assets/css/responsive.css";
import "react-datepicker/dist/react-datepicker.css";

import Login from "./Auth/Login";
import NoMatch from "./pages/NoMatch";
import { Route, Routes, useLocation } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import AuthContext from "./context/AuthContext";
import { routes } from "./Route";
// import ViewDialog from "./pages/RiskManagement/ViewDialog";
// import FancyBetDialog from "./pages/RiskManagement/FancyBetDialog";
// import ViewSportPremium from "./pages/RiskManagement/ViewSportPremium";
import ViewBetsResult from "./pages/ViewBetsResult";
import MarketBets from "./pages/MarketBets";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import LoginMobile from "./Auth/LoginMobile";
import ViewBetsRisk from "./pages/ViewBetsRisk";
import SidebarNew from "./components/SidebarNew";
import useWindowDimensions from "./pages/SportAnalytics/getWindowSize";
import ViewSportPremium from "./pages/RiskManagement/ViewSportPremium";
import FancyBetDialog from "./pages/RiskManagement/FancyBetDialog";
import ViewDialog from "./pages/RiskManagement/ViewDialog";
import Loader from "./components/Loader";
import ShowBetfair from "./pages/RiskManagement/ShowBetfair";
// import ChangePassword from "./pages/ChangePassword";
import ChangePassword from "./Auth/ChangePassword";

function App() {
  let { user, newSidebar, accountError, setAccountError } =
    useContext(AuthContext);

  const { width } = useWindowDimensions();
  useEffect(() => {
    if (accountError) {
      let timer = setTimeout(() => {
        setAccountError(false);
      }, 4000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [accountError]);

  const [suspendMsg, setSuspendMsg] = useState(false);

  useEffect(() => {
    let interval;

    if (user?.status === "suspend") {
      interval = setInterval(() => {
        setSuspendMsg((prev) => !prev);
      }, 2000);
    } else {
      setSuspendMsg(false); // make sure it's hidden if not suspended
    }

    return () => clearInterval(interval); // cleanup on unmount or user change
  }, [user]);
  return (
    <div className={`App ${isMobile && "new-css"} `}>
      {newSidebar && width > 1200 && <SidebarNew />}
      <div
        id="message"
        class="message-wrap info"
        style={accountError ? {} : { display: "none" }}
      >
        <a class="btn-close btn-close-new"></a>
        <p>You have no bet select in this period.</p>
      </div>
      <div
        id="message"
        class="message-wrap info warning-wrap"
        style={suspendMsg ? {} : { display: "none" }}
      >
        <a class="btn-close btn-close-new"></a>
        <p>Account is suspended! Please contact your upline</p>
      </div>
      <Loader />
      <wc-toast position={"top-center"}></wc-toast>
 
      {/* <wc-toast
        position="top-center"
        duration="6000000"
        role="status"
        aria-live="polite"
      >
        <wc-toast-item
          type="success"
          duration="6000000"
          data-toast-item-id="4"
          theme="light"
        >
          <wc-toast-icon
            type="success"
            icon=""
            aria-hidden="true"
          ></wc-toast-icon>
          <wc-toast-content message="STATUS_UPDATE"></wc-toast-content>
        </wc-toast-item>
      </wc-toast> */}

      <Routes>
        <Route element={<PrivateRoute />}>
          {routes?.map((item, index) => {
            return item?.permission?.includes(user?.userType) ? (
              <Route
                exact
                path={item.path}
                key={index}
                element={<item.Component />}
              />
            ) : item?.permission?.length == 0 ? (
              <Route
                exact
                path={item.path}
                key={index}
                element={<item.Component />}
              />
            ) : (
              ""
            );
          })}
        </Route>
        <Route
          exact
          path="/login"
          element={isMobile ? <LoginMobile /> : <Login />}
          // element={<Login />}
        ></Route>
          <Route path="/change-password" element={<ChangePassword />} />
        <Route
          exact
          path="/risk-betfair/:eventId/:marketId"
          element={<ShowBetfair />}
          // element={<Login />}
        ></Route>
        <Route
          exact
          path="/DownlinePnl/:userId/:userType/:id/:marketId/:type"
          element={<ViewDialog />}
        ></Route>
        <Route
          exact
          path="/DownlinePnl-Fancy/:name/:eventid/:marketId/:selectionId"
          element={<FancyBetDialog />}
        ></Route>
        <Route
          exact
          path="/DownlinePnl-sport-premium/:eventId/:selectionId/:marketId/:userType/:userId"
          element={<ViewSportPremium />}
        ></Route>
        <Route
          exact
          path="/view-bets-result/:eventId/:marketId/:selectionId"
          element={<ViewBetsResult />}
        ></Route>
        <Route
          exact
          path="/ViewBets/:userId/:userType/:type/:gameType/:selectionId"
          element={<ViewBetsRisk />}
        ></Route>
        <Route
          exact
          path="/match-market-bets/:eventId/:betFairType"
          element={<MarketBets />}
        ></Route>
        <Route
          exact
          path="/change-password"
          element={<ChangePassword />}
        ></Route>
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </div>
  );
}

export default App;
